
// ------------------- nav animation ---------------


if (window.innerWidth > 1024) {

  const items = document.querySelectorAll('.nav-items a');

  items.forEach(link => {
    const text = link.innerText;
    link.innerHTML = '';

    [...text].forEach(char => {
      const wrapper = document.createElement('span');
      wrapper.classList.add('letter-wrapper');

      const original = document.createElement('span');
      original.classList.add('letter');
      original.textContent = char;

      const clone = document.createElement('span');
      clone.classList.add('letter', 'clone');
      clone.textContent = char;

      wrapper.appendChild(original);
      wrapper.appendChild(clone);
      link.appendChild(wrapper);
    });

    // Hover animations
    link.addEventListener('mouseenter', () => {
      const letters = link.querySelectorAll('.letter-wrapper');
      letters.forEach((wrapper, i) => {
        const original = wrapper.querySelector('.letter:not(.clone)');
        const clone = wrapper.querySelector('.letter.clone');

        gsap.to(original, {
          y: '-100%',
          duration: 0.1,
          ease: 'power1.out',
          delay: i * 0.02
        });

        gsap.to(clone, {
          y: '-100%',
          duration: 0.1,
          ease: 'power1.out',
          delay: i * 0.02,
          color: '#000'
        });
      });
    });

    link.addEventListener('mouseleave', () => {
      const letters = link.querySelectorAll('.letter-wrapper');
      letters.forEach((wrapper, i) => {
        const original = wrapper.querySelector('.letter:not(.clone)');
        const clone = wrapper.querySelector('.letter.clone');

        gsap.to(original, {
          y: '0%',
          duration: 0.1,
          ease: 'power1.out',
          delay: i * 0.02
        });

        gsap.to(clone, {
          y: '0%',
          duration: 0.1,
          ease: 'power1.out',
          delay: i * 0.02
        });
      });
    });
  });
}


// ---------------- fixed product detail container -------------//
// =============================================scroll-up-and-down-both===========================================//

document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('.my-box-gsap-wrapper');
  const box = document.querySelector('.my-box-gsap');
  
  if (!target || !box) return;
  
  const observer = new IntersectionObserver(
    
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
         box.classList.add('fixed');
        } else {
          box.classList.remove('fixed');
        }
      });
    },
    {
      threshold: 0
    }
  );
 
    observer.observe(target);
  });
  
// =============================================scroll-up-and-down-both===========================================//
// =============================================scroll-down===========================================//
  
  // document.addEventListener("DOMContentLoaded", function () {
    //   const target = document.querySelector('.my-box-gsap-wrapper');
    //   const box = document.querySelector('.my-box-gsap');
  
    //   if (!target || !box) return;
    
    //   let lastScrollY = window.scrollY;
    
    //   const observer = new IntersectionObserver(
      //     (entries) => {
        //       entries.forEach(entry => {
          //         let currentScrollY = window.scrollY;
          
          
          //         let scrollingDown = currentScrollY > lastScrollY;
          //         lastScrollY = currentScrollY;
          
          //         if (!entry.isIntersecting && scrollingDown) {
            
          //           box.classList.add('fixed');
          //         } else if (entry.isIntersecting) {
            
          //           box.classList.remove('fixed');
          //         }
          //       });
          //     },
          //     {
            //       threshold: 0
            //     }
            //   );
            
            //   observer.observe(target);
            // });
            
// =============================================scroll-down===========================================//
  

// ---------------- fixed product detail container -------------//












//==================================heder-for menu========================================//

// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".header-wrapper");
  
//   if (!header) return;
  
//   document.addEventListener("scroll", function () {
//     // Get the position just below the header
//     const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
//     const centerX = window.innerWidth / 2;
//     const elementBelow = document.elementFromPoint(centerX, headerBottom - window.scrollY + 1);
//     const checker = (elementBelow.closest(".hero-detail") || elementBelow.classList.contains("hero-detail")) ? true : false;
//     if (!elementBelow) return;
    
//     const tag = elementBelow.tagName.toLowerCase();
    
//     if (tag == 'img' || tag == 'video' || checker) {
//       header.classList.add("header--on-media");
//     } 
//     else {
//       header.classList.remove("header--on-media");
//     }
//   });
// });
function headerColorChange(header,footer3d){
  const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
    const centerX = window.innerWidth / 2;
    const elementBelow = document.elementFromPoint(centerX, headerBottom - window.scrollY + 1);
   
    if (!elementBelow) return;
 
    const tag = elementBelow.tagName.toLowerCase();
 

    const inFooter3D = elementBelow.closest(".cust-3d-footer");
 
    if (inFooter3D) {
      header.classList.remove("header--on-media");
      return;
    }
 
    const isMedia = (tag === 'img' || tag === 'video');
    const inHeroDetail = elementBelow.closest(".hero-detail") || elementBelow.classList.contains("hero-detail");
 
    if (isMedia || inHeroDetail) {
      header.classList.add("header--on-media");
    } else {
      header.classList.remove("header--on-media");
    }
}

document.addEventListener("DOMContentLoaded", function () {
   const header = document.querySelector(".header-wrapper");
  const footer3d = document.querySelector(".cust-3d-footer");
  if (!header) return;
  if(location.pathname.includes("/products/")) return;
    headerColorChange(header,footer3d)
  document.addEventListener("scroll", function () {
    headerColorChange(header,footer3d)
  });
});
 

// -------------------------------------


// -----------------------------------------moblie-view-for text-glass-------------------------------------//


// gsap.registerPlugin(ScrollTrigger);

// ScrollTrigger.matchMedia({

//   "(max-width: 950px)": function () {

//     let panels = gsap.utils.toArray(".text-box-moblie"); 
//     let container = document.querySelector(".cust_imagetext_section");

//     gsap.to(panels, {
//       yPercent: -100 * (panels.length - 1),  
//       ease: "none",
//       scrollTrigger: {
//         trigger: container,
//         pin: true,
//         scrub: 1,
//         snap: 1 / (panels.length - 1), 
//         end: "+=" + (panels.length * 15) + "%", 
//       }
//     });

//   }

// });

// gsap.registerPlugin(ScrollTrigger);
// const circle = document.querySelector("#progress");
// const bubbles = gsap.utils.toArray(".bubble");
// const centerContent = document.querySelector(".center-content");

// let tl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".circle-section",
//     start: "top top",
//     end: "+=1500", 
//     scrub: true,
//     pin: true,
//   }
// });

// tl.to(circle, {
//   strokeDashoffset: 0,
//   ease: "none",
// }, 0);

// bubbles.forEach((bubble, i) => {
//   let fromVars = { opacity: 0, scale: 0.5 };
//   tl.fromTo(
//     bubble,
//     fromVars,
//     { opacity: 1, scale: 1, ease: "back.out(1.7)" },
//     i * 0.5 + 0.5
//   );
// });

// tl.fromTo(centerContent,
//   { opacity: 0, scale: 0.5, y: 50 },
//   { opacity: 1, scale: 1, y: 0, ease: "back.out(1.7)" },
// );


// ScrollTrigger.matchMedia({
//   "(max-width: 950px)": function () {
//     let panels = gsap.utils.toArray(".text-box-moblie");
//     let container = document.querySelector(".cust_imagetext_section");

//     gsap.to(panels, {
//       yPercent: -100 * (panels.length - 1),
//       ease: "none",
//       scrollTrigger: {
//         trigger: container,
//         start: "top top",
//         end: "+=" + (panels.length * 20) + "%",
//         pin: true,
//         scrub: 1,
//         snap: 1 / (panels.length - 1),
//       }
//     });
//   }
// });


// -----------------------------------------moblie-view-for text-glass-------------------------------------// 



 
 
// =================== Draggable JS ========================


function enableLeftClickDragScroll(container) {
  if (!container) return;

  let isDragging = false;
  let dragStarted = false;
  let startX = 0;
  let scrollStart = 0;
  const dragThreshold =1;

  container.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    isDragging = true;
    dragStarted = false;
    startX = e.pageX;
    scrollStart = container.scrollLeft;
    container.classList.add("is-dragging");
    e.preventDefault();
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;

    if (!dragStarted && Math.abs(deltaX) > dragThreshold) {
      dragStarted = true;
    }

    if (dragStarted) {
      container.scrollLeft = scrollStart - deltaX;
    }
  });

  container.addEventListener("mouseup", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mouseleave", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("click", (e) => {
    if (dragStarted) {
      e.preventDefault();
      e.stopPropagation();
      dragStarted = false;
    }
  });

  container.classList.add("is-draggable");
}

function waitForElementAndInit(selector) {
  // Initialize any that already exist
  document.querySelectorAll(selector).forEach(el => {
    if (!el._dragInitialized) {
      enableLeftClickDragScroll(el);
      el._dragInitialized = true;
    }
  });

  // Observe future additions
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(selector) && !node._dragInitialized) {
          enableLeftClickDragScroll(node);
          node._dragInitialized = true;
        }

        // Check descendants too
        node.querySelectorAll?.(selector)?.forEach((el) => {
          if (!el._dragInitialized) {
            enableLeftClickDragScroll(el);
            el._dragInitialized = true;
          }
        });
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // ===============================================
  // ADD CLASS OR ID OF CONTAINER TO SCROLL [ DEV-03 ]
  // ===============================================
  const scrollSelectors = [".product__media-list",".peoduct_card"];

  scrollSelectors.forEach(selector => {
    waitForElementAndInit(selector);
  });
});

// --------- Draggable JS ---------
 